import { ReactNode } from "react";

import { cn } from "@/libs/cn";

import { TotalizersCard, TotalizersCardSkeleton } from "../TotalizersCard";

export interface TotalizerCardConfig {
  key: string;
  title: string;
  value?: ReactNode;
  subValue?: ReactNode;
  icon: React.ReactNode;
  iconWrapperClassName: string;
}

interface TotalizersGridProps {
  items: TotalizerCardConfig[];
  isLoading?: boolean;
  className?: string;
}

const TotalizersGrid = ({ items, isLoading = false, className }: TotalizersGridProps) => (
  <div className={cn("grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 items-stretch", className)}>
    {items.map((item) => {
      const hasTitle = !!item.title;
      const hasValue = item.value !== undefined;
      const hasSubValue = item.subValue !== undefined;

      return isLoading ? (
        <TotalizersCardSkeleton key={item.key} hasTitle={hasTitle} hasValue={hasValue} hasSubValue={hasSubValue} />
      ) : (
        <TotalizersCard
          key={item.key}
          title={item.title}
          value={item.value}
          subValue={item.subValue}
          icon={<div className={cn("flex items-center justify-center p-2 rounded-lg", item.iconWrapperClassName)}>{item.icon}</div>}
        />
      );
    })}
  </div>
);

export default TotalizersGrid;
